import Vue from 'vue'
import Router from 'vue-router'
import {EventBus} from "../utilites/eventBus"

import workers from "./workers";
import catalogs from "./catalogs";
import customers from "./customers";
import organizations from "./organizations";
import login from "./login";
import statistics from "./statistics";
import registers from "./register";
import users from "./users";
import tasks from "./tasks";
import locations from "./locations";
import invoices from "./invoices";
import analytics from "./analytics";
import reports from "./reports";
import reconciliationActs from "./reconciliationActs";
import staffs from "./staffs";
import salaries from "./salaries";
import accruals from "./accruals";
import salarySummary from "./salarySummary";
import recruitTask from "./recruitTasks";
import userRoles from "./userRoles";
import home from "./home";
import recruitJobPostings from "./recruitJobPostings";
import recruitLocationVacancies from "./recruitLocationVacancies";

Vue.use(Router);

const routes = [
  {
    path: '',
    redirect: '/home',
  },
  {
    path: '*',
    component: {
      render: template => template('div'),
      created() {
        EventBus.$emit('http-error-404');
      }
    }
  },
  ...home,
  ...login,
  ...customers,
  ...organizations,
  ...statistics,
  ...registers,
  ...users,
  ...tasks,
  ...workers,
  ...locations,
  ...invoices,
  ...analytics,
  ...reports,
  ...catalogs,
  ...reconciliationActs,
  ...staffs,
  ...salaries,
  ...accruals,
  ...salarySummary,
  ...recruitTask,
  ...userRoles,
  ...recruitJobPostings,
  ...recruitLocationVacancies
];

const router = new Router({routes, mode: 'history'});

router.beforeEach((to, from, next) => {
  const role = localStorage.getItem('role');
  const token = localStorage.getItem('token');
  const permissions = localStorage.getItem('permissions');
  const isAuthenticated = token != null && role != null;
  const triggerForbidden = () => {
    EventBus.$emit('http-error-403');

    if (from.name === null) {
      // TODO: Возвращать на страницу к которой есть доступ
      next({name: 'Home'});
    } else {
      next(false);
    }
  }

  if (to.meta.requiresAuth) {
    if (!isAuthenticated) {
      next({name: 'Login'})
      return;
    }

    // Проверка через permissions
    if (to.meta.permissions) {
      const hasPermission = (statePermissions, permissions) => {
        if (statePermissions != null && statePermissions.length === 0) {
          return false;
        }
        const storedPermissions = statePermissions.split(',');
        if (storedPermissions == null || storedPermissions.length === 0) {
          return false;
        }
        return permissions.every(v => storedPermissions.includes(v));
      }

      if (hasPermission(permissions, to.meta.permissions)) {
        next();
        return;
      } else {
        // Если первый раз заходим на страницу, то пропускаем вывод ошибки и отображаем triggerForbidden()
        // Иначе возвращаем ошибку и обрабатываем её там откуда вызываем переход
        if (from.path !== "/") {
          const error = new Error('Permission denied');
          error.name = 'permissions';
          next(error);
          return;
        }

        triggerForbidden();
        return;
      }
    }

    // Проверка через роли
    if (to.meta.admin) {
      if (role === 'admin') {
        next();
        return;
      }
    }
    if (to.meta.manager) {
      if (role === 'manager' || role === 'coordinator') {
        next();
        return;
      }
    }
    if (to.meta.accountant) {
      if (role === 'accountant') {
        next();
        return;
      }
    }
    if (to.meta.marketer) {
      if (role === 'marketer') {
        next();
        return;
      }
    }

    if (to.meta.project) {
      if (role === 'project') {
        next();
        return;
      }
    }

    if (to.meta.operator) {
      if (role === 'operator') {
        next();
        return;
      }
    }

    triggerForbidden();
  } else {
    if (isAuthenticated && ['Login'].includes(to.name)) {
      // TODO: Перебрасывать на страницу к которой есть доступ
      next({name: 'Home'});
      return;
    }

    next()
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js